import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const MapItemDetailSkeleton = ({ layerId }: { layerId: number }) => {
    const sectionCount = 7;

    return layerId !== 108 ? (
        <div className="max-w-2xl mx-auto bg-white border border-t-0 border-gray-300 shadow-lg">
            <div className="flex items-center p-4 border-b">
                <Skeleton height={24} width={240} />
            </div>

            <Skeleton height={200} />

            <div className="p-4 border-b border-gray-300">
                <Skeleton count={3} height={10} style={{ marginBottom: 4 }} />
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300">
                <div className="p-3 flex items-center border-r border-gray-300 font-semibold text-xs">
                <Skeleton width={60} height={12} />
                </div>
                <div className="p-3 text-xs">
                <Skeleton width={100} height={12} />
                </div>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300">
                <div className="p-3 border-r border-gray-300 font-semibold text-xs">
                <Skeleton width={60} height={12} />
                </div>
                <div className="p-3 text-xs">
                <Skeleton width={120} height={12} />
                </div>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300">
                <div className="p-3 border-r border-gray-300 font-semibold text-xs">
                <Skeleton width={80} height={12} />
                </div>
                <div className="p-3 text-xs">
                <Skeleton width={100} height={12} />
                </div>
            </div>

            {[...Array(sectionCount)].map((_, idx) => (
                <div key={idx} className="border-b border-gray-300">
                    <div className="w-full py-3 px-4 bg-gray-50">
                        <div className="flex items-center justify-between">
                        <div className="flex items-start space-x-2">
                            <Skeleton circle width={20} height={20} />
                            <div className="flex flex-col text-left">
                                <Skeleton width={100} height={12} />
                                <Skeleton width={80} height={8} />
                            </div>
                        </div>
                        <Skeleton width={12} height={12} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
    :
    (<div className="max-w-2xl mx-auto bg-white border border-t-0 border-gray-300 shadow-lg">
            {/* Header */}
            <div className="p-6 flex justify-between items-center">
                <Skeleton height={24} width={240} />
            </div>

            {/* General Info Section */}
            <div className="px-6 pt-4 space-y-4">
                {/* Activity Date */}
                <div className="flex flex-col items-start space-y-1">
                    <Skeleton width={100} height={12} />
                    <Skeleton width={"30vw"} height={10} />
                </div>

                {/* Description */}
                <div className="flex flex-col items-start space-y-1">
                    <Skeleton width={"20vw"} height={12} />
                    <Skeleton count={2} width={"80vw"} height={12} />
                </div>

                {/* Category */}
                <div className="flex flex-col items-start space-y-1">
                    <Skeleton width={60} height={12} />
                    <Skeleton width={"70vw"} height={12} />
                </div>

                {/* Value */}
                <div className="flex flex-col items-start space-y-1">
                    <Skeleton width={60} height={12} />
                    <Skeleton width={100} height={12} />
                </div>
            </div>

            {/* Attribute Table */}
            <div className="p-6 space-y-4 text-gray-700">
                <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold">
                                    <Skeleton width={40} height={10} />
                                </th>
                                <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold">
                                    <Skeleton width={40} height={10} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...Array(10)].map((_, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="border border-gray-300 px-4 py-2 text-xs">
                                        <Skeleton width={100} height={10} />
                                    </td>
                                    <td className="border border-gray-300 px-4 py-2 text-xs">
                                        <Skeleton width="80%" height={10} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>)
};

export default MapItemDetailSkeleton;
